import {
  ChakraBox as Box,
  ChakraPopover,
  ChakraPopoverContent as PopoverContent,
  ChakraPopoverTrigger as PopoverTrigger,
} from "@airhelp/react-ui-components";
import { createIcon } from "@chakra-ui/react";
import { RichtextAdapter } from "modules/storyblok/adapters";
import { isEmpty } from "modules/storyblok/adapters/RichtextAdapter/utils";
import type { SbEditableComponentProps } from "types/storyblok";
import type { PopoverProps } from "./Popover.d";
import { customStyles } from "./Popover.styles";

// TODO | Remove once it will be added to the RUIC
const InfoIcon = createIcon({
  displayName: "InfoIcon",
  viewBox: "0 0 17 16",
  path: (
    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.16667 2.00562C4.49266 2.00562 1.5 4.99828 1.5 8.67228C1.5 12.3463 4.49266 15.3389 8.16667 15.3389C11.8407 15.3389 14.8333 12.3463 14.8333 8.67228C14.8333 4.99828 11.8407 2.00562 8.16667 2.00562ZM8.16667 3.33895C11.1201 3.33895 13.5 5.71887 13.5 8.67228C13.5 11.6257 11.1201 14.0056 8.16667 14.0056C5.21325 14.0056 2.83333 11.6257 2.83333 8.67228C2.83333 5.71887 5.21325 3.33895 8.16667 3.33895ZM7.5 5.33895V6.67228H8.83333V5.33895H7.5ZM7.5 8.00562V12.0056H8.83333V8.00562H7.5Z"
        fill="currentColor"
      />
    </svg>
  ),
});

export const Popover = ({
  content,
  sbEditable,
  backgroundColor,
  color,
  iconColor,
}: SbEditableComponentProps<PopoverProps>) => (
  <ChakraPopover trigger="hover" placement="top-start" {...sbEditable}>
    <PopoverTrigger>
      <Box as="span" role="button">
        <InfoIcon ml={0.5} mb={1} color={iconColor} />
      </Box>
    </PopoverTrigger>
    <PopoverContent bg={backgroundColor} px={6} py={4} sx={{ p: { color }, color }}>
      {!isEmpty(content) && <RichtextAdapter content={content} customStyles={customStyles} />}
    </PopoverContent>
  </ChakraPopover>
);
